import styled from "styled-components";
import SubmitUi from "../../../../../../components/Form/Submit";

const red = ({ theme }) => theme.colors.Primary;

export const Title = styled("h3")`
  margin: 0px;
`;

export const Quiz = styled("div")`
  /* Slider */
  .slick-slider {
    position: relative;

    display: block;
    box-sizing: border-box;

    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-touch-callout: none;
    -khtml-user-select: none;
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-tap-highlight-color: transparent;
  }

  .slick-list {
    position: relative;

    display: block;
    overflow: hidden;

    margin: 0;
    padding: 0;
  }
  .slick-list:focus {
    outline: none;
  }
  .slick-list.dragging {
    cursor: pointer;
    cursor: hand;
  }

  .slick-slider .slick-track,
  .slick-slider .slick-list {
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
    -o-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  .slick-track {
    position: relative;
    top: 0;
    left: 0;

    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .slick-track:before,
  .slick-track:after {
    display: table;

    content: "";
  }
  .slick-track:after {
    clear: both;
  }
  .slick-loading .slick-track {
    visibility: hidden;
  }

  .slick-slide {
    display: none;
    float: left;

    height: 100%;
    min-height: 1px;
  }
  [dir="rtl"] .slick-slide {
    float: right;
  }
  .slick-slide img {
    display: block;
  }
  .slick-slide.slick-loading img {
    display: none;
  }
  .slick-slide.dragging img {
    pointer-events: none;
  }
  .slick-initialized .slick-slide {
    display: block;
  }
  .slick-loading .slick-slide {
    visibility: hidden;
  }
  .slick-vertical .slick-slide {
    display: block;

    height: auto;

    border: 1px solid transparent;
  }
  .slick-arrow {
    display: none !important;
  }
  .slick-arrow.slick-hidden {
    display: none;
  }
`;

export const Content = styled("div")`
  padding: 0px 34px;
`;

export const Steps = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`;

export const Step = styled("div")`
  width: 12px;
  height: 12px;
  background-color: ${({ completed, active }) => {
    if (active) return "white";
    return completed ? red : "white";
  }};
  border-radius: 100%;
  z-index: 2;
  border: ${({ completed, active }) => {
    if (active) return `2px solid`;
    return completed ? "none" : "2px solid";
  }};
  border-color: ${({ completed, active }) => {
    if (active) return red;
    return completed ? "none" : "gray";
  }};

`;

export const ProgressBar = styled("div")`
  content: "";
  height: 2px;
  background-color: ${({ theme }) => theme.colors.Primary};
  width: ${({ completionPercentage }) => `${completionPercentage}%`};
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 1;
`;

export const ProgressBarWhite = styled("div")`
  content: "";
  height: 2px;
  background-color: gray;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  z-index: 0;
`;

export const Question = styled("p")`
  margin: 0px;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
`;

export const Answer = styled("div")`
  height: 34px;
  border-radius: 10px;
  background-color: rgba(242, 242, 242, 0.5);
  font-size: 12px;
  padding: 0px 11px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Radio = styled("input")``;

export const Checkbox = styled("input")``;

export const Actions = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Prev = styled("button")`
  height: 27px;
  border-radius: 4px;
  box-shadow: 0px 0px 10px 0px rbga(0, 0, 0, 1);
  border: 0px;
  margin: 0px;
  padding: 0px 10px;
  border: 1px solid rgba(34, 45, 50, 1);
  color: rgba(34, 45, 50, 1);
  font-size: 12px;
  font-weight: 500;
  background-color: transparent;
  display: flex;
  align-items: center;
  gap: 5px;

  &.slick-disabled {
    opacity: 0;
    pointer-events: none;
  }
`;

export const Next = styled("button")`
  height: 27px;
  border-radius: 4px;
  box-shadow: 0px 0px 10px 0px rbga(0, 0, 0, 1);
  border: 0px;
  margin: 0px;
  padding: 0px 10px;
  color: white;
  background-color: ${({ theme }) => theme.colors.Primary};
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;

  &.slick-disabled {
    opacity: 0;
    pointer-events: none;
  }
`;

export const Submit = styled(SubmitUi)`
  height: 27px;
  border-radius: 4px;
  box-shadow: 0px 0px 10px 0px rbga(0, 0, 0, 1);
  border: 0px;
  margin: 0px;
  padding: 0px 10px;
  color: white;
  background-color: ${({ theme }) => theme.colors.Primary};
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 5px;

  &.slick-disabled {
    opacity: 0;
    pointer-events: none;
  }
`;

export const ErrorMessage = styled("div")``;
